// Response contract for POST api/v2/sign-up/precheck-email, discriminated by `outcome`. Like Prelogin.ts, but
// sign-up may be existence-revealing, so registered vs. unknown accounts route differently (ALREADY_REGISTERED vs. PROCEED).
export const SignUpPrecheckOutcome = {
  SsoRedirect: "SSO_REDIRECT",
  SsoIdpOnly: "SSO_IDP_ONLY",
  AlreadyRegistered: "ALREADY_REGISTERED",
  Inactive: "INACTIVE",
  Proceed: "PROCEED"
} as const

export type SignUpPrecheckSso = {
  idpEntityId: string
}

export type SignUpPrecheckResponse =
  | { outcome: typeof SignUpPrecheckOutcome.SsoRedirect; sso: SignUpPrecheckSso }
  | { outcome: typeof SignUpPrecheckOutcome.SsoIdpOnly }
  | { outcome: typeof SignUpPrecheckOutcome.AlreadyRegistered }
  | { outcome: typeof SignUpPrecheckOutcome.Inactive }
  | { outcome: typeof SignUpPrecheckOutcome.Proceed }
